import * as React from 'react';
import './styles.scss';
// import Webcam from "react-webcam";
export interface WebCamFunProps {}
export default class WebCamFun extends React.Component<WebCamFunProps> {
    public render(): JSX.Element {
        return (
            <div>
                <div className="bg">
                             
                </div>
            </div>
        );
    }
}
